export default {
  // Meta Tags (for social media previews)
  metaTitle: '{{petName}}\'s Care Information',
  metaDescription: 'View {{petName}}\'s detailed care information, including dietary, health, behavior, and more',
  
  // Loading & Error States
  loadingPet: 'Loading pet data...',
  petInfoNotFound: 'Pet Information Not Found',
  linkExpiredOrIncorrect: 'This share link has expired or is incorrect',
  backToHome: 'Back to Home',
  
  // Age & Time
  year: 'year',
  years: 'years',
  month: 'month',
  months: 'months',
  unknown: 'Unknown',
  
  // Security
  securityReminder: 'Security Reminder',
  shareOnlyWithTrusted: 'This data contains your pet\'s personal data. Please only share with trusted caregivers.'
};